module.exports = __webpack_public_path__ + "static/media/TZPT_Hydrotech.477254fd.jpg";